import { ApolloProvider } from "@apollo/client";
import { Elements } from "@stripe/react-stripe-js";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./assets/styles/index.scss";
import Container from "./containers/Container";
import { client } from "./services/graphql";
import { stripe } from "./services/stripe";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store/configureStore";

export const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Elements stripe={stripe}>
      <ApolloProvider client={client}>
        <Container />
      </ApolloProvider>
    </Elements>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
